import videoEmptyTrack from '../../../assets/video_empty_tracking.mp4';
import React from 'react';

export default function OfferFollowNoDataChart() {

    return (
        <>
            <video
                autoPlay
                loop
                src={videoEmptyTrack}
                height={250}
                width={250}/>
            <p style={{
                marginTop: '16px',
                backgroundColor: '#e9f0f8',
                padding: '16px',
                textAlign: 'justify',
                fontSize: '13px',
                borderRadius: '8px',
                fontWeight: '400'
            }}>
                <span style={{color: '#000000', fontWeight: '800', fontSize: '15px'}}>Nota:&ensp;</span>
                Tu seguimiento solo mostrará información de anuncios activos a partir de mañana a las 7:30 am.
                <br/><br/>
                Hacemos esto para garantizar que la comparación de anuncios se realice siempre al mismo tiempo.
            </p>
        </>
    );
}
